@if (receipt) {
    @if (!errorStatusCode) {
        <base-site-layout
            [heading]="'Lieferschein \{\{number\}\}' | translate: { number: receipt.data.number }"
            [isDialog]="isDialog"
            (dialogCloseClicked)="closeDialog()"
        >
            @if (
                receipt.possibleActions.includes(deliveryReceiptPossibleActionType.CREATE_INVOICE) &&
                !receipt.data.inApproval
            ) {
                <base-site-layout-action>
                    <button
                        class="btn btn-outline-dark"
                        [routerLink]="'/' + View.CLIENT + '/my-admin/invoice/create/standalone'"
                        [queryParams]="{ receiptId: receipt.data.id, receiptNumber: receipt.data.number }"
                    >
                        <i class="fas fa-file-invoice"></i>
                        {{ 'Rechnung erfassen' | translate }}
                    </button>
                </base-site-layout-action>
            }
            @if (
                receipt.possibleActions.includes(deliveryReceiptPossibleActionType.WAREHOUSE_ADD) && hasUnstockedItems
            ) {
                <base-site-layout-action *showOnActiveWarehouse>
                    <button class="btn btn-outline-dark" (click)="stockEverything()">
                        <em class="fas fa-boxes"></em>
                        ➟
                        <em class="fas fa-box-open pe-1"></em>
                        {{ 'alles einlagern' | translate }}
                    </button>
                </base-site-layout-action>
            }
            <document-layout>
                <document-sidemenu-section>
                    <document-sidemenu-section-header
                        [sectionTitle]="'Verknüpfte Dokumente' | translate"
                        icon="fas fa-diagram-project"
                    ></document-sidemenu-section-header>
                    <document-sidemenu-section-empty-message>
                        {{ 'Keine verknüpften Dokumente' | translate }}
                    </document-sidemenu-section-empty-message>
                    <ng-template #processChainCard let-linkedDocument>
                        <process-chain-related-document
                            [document]="linkedDocument"
                            [navigationAvailable]="!!linkedDocument.targetRoute"
                        ></process-chain-related-document>
                    </ng-template>
                    @for (
                        linkedDocument of linkedProcessDocuments();
                        track linkedDocument.documentType + '|' + linkedDocument.documentId
                    ) {
                        @if (linkedDocument.targetRoute) {
                            <document-sidemenu-card (cardClick)="navigateToLinkedDocument(linkedDocument)">
                                <ng-container
                                    *ngTemplateOutlet="processChainCard; context: { $implicit: linkedDocument }"
                                ></ng-container>
                            </document-sidemenu-card>
                        } @else {
                            <document-sidemenu-card>
                                <ng-container
                                    *ngTemplateOutlet="processChainCard; context: { $implicit: linkedDocument }"
                                ></ng-container>
                            </document-sidemenu-card>
                        }
                    }
                </document-sidemenu-section>
                <document-sidemenu-section>
                    <document-sidemenu-section-header
                        [sectionTitle]="'Anhänge' | translate"
                        icon="fas fa-paperclip"
                    ></document-sidemenu-section-header>
                    <document-sidemenu-section-empty-message>
                        {{ 'Keine Anhänge vorhanden' | translate }}
                    </document-sidemenu-section-empty-message>
                    <document-sidemenu-section-action (actionClick)="upload()"></document-sidemenu-section-action>
                    @for (file of receipt.data.files; track file.id) {
                        <document-sidemenu-card>
                            <document-sidemenu-attachment [file]="file"></document-sidemenu-attachment>
                        </document-sidemenu-card>
                    }
                </document-sidemenu-section>
                @if (receipt) {
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 mb-2">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl mb-2 p-md-2 p-lg-2 p-xl-2">
                                        <iim-card [header]="'Allgemein' | translate">
                                            <div class="px-2">
                                                @if (receipt.data.number) {
                                                    <div class="row font-12 margin-bottom-10">
                                                        <div class="col-xl-5 col-lg-5 col-md-4 col-sm-6 col-xs-12">
                                                            <strong>{{ 'Nummer' | translate }}:</strong>
                                                        </div>
                                                        <div class="col">
                                                            <span copyToClipboard>{{ receipt.data.number }}</span>
                                                        </div>
                                                    </div>
                                                }
                                                @if (receipt.data.deliveryDate) {
                                                    <div class="row">
                                                        <div class="col-xl-5 col-lg-5 col-md-4 col-sm-6 col-xs-12">
                                                            <strong>{{ 'Lieferdatum' | translate }}:</strong>
                                                        </div>
                                                        <div class="col">
                                                            {{ receipt.data.deliveryDate | dayjs: 'DD.MM.YYYY' }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (receipt.data.createDate) {
                                                    <div class="row">
                                                        <div class="col-xl-5 col-lg-5 col-md-4 col-sm-6 col-xs-12">
                                                            <strong>{{ 'Buchungsdatum' | translate }}:</strong>
                                                        </div>
                                                        <div class="col">
                                                            {{ receipt.data.createDate | dayjs: 'DD.MM.YYYY' }}
                                                        </div>
                                                    </div>
                                                }
                                                @if (displayCompanyCode) {
                                                    <div class="row">
                                                        <div class="col-xl-5 col-lg-5 col-md-4 col-sm-6 col-xs-12">
                                                            <strong>{{ 'Buchungskreis' | translate }}:</strong>
                                                        </div>
                                                        <div class="col">
                                                            {{ selectedCompanyCode?.code }}
                                                            @if (selectedCompanyCode?.name) {
                                                                <span class="text-description">
                                                                    - {{ selectedCompanyCode?.name }}
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                @if (receipt.data.invoiceNumber) {
                                                    <div class="row">
                                                        <div class="col-xl-5 col-lg-5 col-md-4 col-sm-6 col-xs-12">
                                                            <strong>{{ 'Rechnungsnummer' | translate }}:</strong>
                                                        </div>
                                                        <div class="col">
                                                            <span
                                                                copyToClipboard
                                                                class="text-primary cursor-pointer"
                                                                [title]="'Rechnung anzeigen' | translate"
                                                                [routerLink]="
                                                                    '/' +
                                                                    View.CLIENT +
                                                                    '/my-admin/invoice/' +
                                                                    receipt.data.invoiceId +
                                                                    '/detail'
                                                                "
                                                            >
                                                                {{ receipt.data.invoiceNumber }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="row margin-top-20">
                                                        <div class="col">
                                                            <span
                                                                class="badge bg-success font-07 p-1 px-2 rounded-pill"
                                                            >
                                                                {{ 'Lieferschein ist abgerechnet' | translate }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                } @else if (receipt.data.inApproval) {
                                                    <div class="row margin-top-20">
                                                        <div class="col">
                                                            <span
                                                                class="badge bg-warning font-07 p-1 px-2 rounded-pill"
                                                            >
                                                                {{ 'Lieferschein ist in Freigabe' | translate }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                } @else {
                                                    <div class="row margin-top-20">
                                                        <div class="col">
                                                            <span class="badge bg-info font-07 p-1 px-2 rounded-pill">
                                                                {{
                                                                    'Lieferschein wurde noch nicht abgerechnet'
                                                                        | translate
                                                                }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </iim-card>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl mb-2 p-md-2 p-lg-2 p-xl-2">
                                        <iim-card [header]="'Lieferant' | translate">
                                            <company-address
                                                [companyNameLine1Override]="
                                                    receipt.data.supplier.companyAddress.companyName?.line1
                                                        ? (receipt.data.supplier.companyAddress.companyName.line1
                                                          | supplierDisplayName: receipt.data.supplier.supplierNumber)
                                                        : null
                                                "
                                                [companyAddress]="receipt.data.supplier.companyAddress"
                                                [contacts]="receipt.data.supplier.contacts"
                                            ></company-address>
                                        </iim-card>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl mb-2 p-md-2 p-lg-2 p-xl-2">
                                        <iim-card [header]="'Kunde' | translate">
                                            <company-address
                                                [companyAddress]="receipt.data.shippingAddress.companyAddress"
                                                [personName]="receipt.data.shippingAddress.personName"
                                            ></company-address>
                                        </iim-card>
                                    </div>
                                    @if (receipt.data.comment) {
                                        <div class="col-sm-12 col-md-6 col-lg-6 col-xl mb-2 p-md-2 p-lg-2 p-xl-2">
                                            <iim-card [header]="commentHeader">
                                                <ng-template #commentHeader>
                                                    <div class="col">
                                                        <div class="row align-items-center">
                                                            <div class="col">
                                                                <div class="row">
                                                                    <div class="col">
                                                                        <h5>
                                                                            {{ 'Kommentar' | translate }}
                                                                            <em
                                                                                class="fas fa-info-circle text-description ms-2"
                                                                                [matTooltip]="
                                                                                    'Kommentare können nur während der Erstellung bearbeitet werden'
                                                                                        | translate
                                                                                "
                                                                                matTooltipPosition="right"
                                                                            ></em>
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                                <div class="col">
                                                    <span
                                                        class="d-flex justify-content-end align-items-end text-description font-09"
                                                    >
                                                        {{ commentCtrl.value?.length }} / {{ COMMENT_MAX_LENGTH }}
                                                        {{ 'Zeichen' | translate }}
                                                    </span>
                                                    <textarea
                                                        id="commentInput"
                                                        class="form-control"
                                                        rows="3"
                                                        [maxLength]="COMMENT_MAX_LENGTH"
                                                        [formControl]="commentCtrl"
                                                        [matTooltip]="
                                                            'Kommentare können nur während der Erstellung bearbeitet werden'
                                                                | translate
                                                        "
                                                        matTooltipPosition="right"
                                                        [matTooltipDisabled]="false"
                                                        readonly
                                                    ></textarea>
                                                </div>
                                            </iim-card>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="col-12 mt-2 mt-lg-2 mt-sm-0">
                                @for (items of receiptsGroupedByOrder | keyvalue; track items) {
                                    <div class="row margin-bottom-10">
                                        <div class="col">
                                            <iim-card
                                                [header]="
                                                    'Gelieferte Artikel aus Bestellung \{\{orderNumber\}\}'
                                                        | translate
                                                            : {
                                                                  orderNumber:
                                                                      items.value[0]?.displayOrderNumber || items.key,
                                                              }
                                                "
                                            >
                                                @for (item of items.value; track item.id) {
                                                    <document-item [imagePreview]="true">
                                                        <document-item-position-indicator>
                                                            {{
                                                                'Position \{\{position\}\}'
                                                                    | translate
                                                                        : {
                                                                              position: item.positionReceipt,
                                                                          }
                                                            }}
                                                        </document-item-position-indicator>
                                                        <document-item-name>
                                                            {{ item.name }}
                                                        </document-item-name>
                                                        <document-item-description>
                                                            <p>{{ item.shortDescription }}</p>
                                                        </document-item-description>
                                                        @if (+item.quantityStocked < +item.quantity) {
                                                            <ng-container>
                                                                @if (
                                                                    receipt.possibleActions.includes(
                                                                        deliveryReceiptPossibleActionType.WAREHOUSE_ADD
                                                                    )
                                                                ) {
                                                                    <document-item-action
                                                                        *acl="{
                                                                            resource: AclResource.clientWarehouse,
                                                                            action: WarehouseAclAction.STOCK_IN,
                                                                        }"
                                                                        [actionLabel]="'Einlagern' | translate"
                                                                        colorClass="text-primary"
                                                                        (triggered)="item.addToStorage()"
                                                                    >
                                                                        <document-item-action-icon>
                                                                            <em class="fas fa-boxes text-primary"></em>
                                                                            <span class="text-primary">➟</span>
                                                                            <em
                                                                                class="fas fa-box-open text-primary"
                                                                            ></em>
                                                                        </document-item-action-icon>
                                                                    </document-item-action>
                                                                    <ng-container *showIfApp>
                                                                        <document-item-action
                                                                            [actionLabel]="
                                                                                'Einlagern per QR Code' | translate
                                                                            "
                                                                            colorClass="text-primary"
                                                                            icon="fas fa-qrcode"
                                                                            (triggered)="item.scanToInsertIntoStorage()"
                                                                        ></document-item-action>
                                                                    </ng-container>
                                                                }
                                                            </ng-container>
                                                        }
                                                        <document-item-attribute>
                                                            <document-item-label>
                                                                {{ 'Bestellnummer' | translate }}
                                                            </document-item-label>
                                                            <document-item-value>
                                                                <span
                                                                    class="cursor-pointer text-primary"
                                                                    copyToClipboard
                                                                    [routerLink]="
                                                                        '/' +
                                                                        View.CLIENT +
                                                                        '/order/' +
                                                                        item.orderNumber +
                                                                        '/detail'
                                                                    "
                                                                >
                                                                    {{ item.displayOrderNumber }}
                                                                </span>
                                                            </document-item-value>
                                                        </document-item-attribute>
                                                        <document-item-attribute [spacingBelow]="true">
                                                            <document-item-label>
                                                                {{ 'Bestellposition' | translate }}
                                                            </document-item-label>
                                                            <document-item-value>
                                                                {{ item.positionOrder }}
                                                            </document-item-value>
                                                        </document-item-attribute>
                                                        @if (item.manufacturer) {
                                                            <document-item-attribute>
                                                                <document-item-label>
                                                                    {{ 'Hersteller' | translate }}
                                                                </document-item-label>
                                                                <document-item-value>
                                                                    {{ item.manufacturer }}
                                                                </document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        @if (item.manufacturerArticleSku) {
                                                            <document-item-attribute>
                                                                <document-item-label>
                                                                    {{ 'Art. Nr. Hersteller' | translate }}
                                                                </document-item-label>
                                                                <document-item-value>
                                                                    {{ item.manufacturerArticleSku }}
                                                                </document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        @if (item.articleNumberSupplier) {
                                                            <document-item-attribute [spacingAbove]="true">
                                                                <document-item-label>
                                                                    {{ 'Art. Nr. Lieferant' | translate }}
                                                                </document-item-label>
                                                                <document-item-value>
                                                                    {{ item.articleNumberSupplier }}
                                                                </document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        @if (item.customerArticleSku) {
                                                            <document-item-attribute [spacingAbove]="true">
                                                                <document-item-label>
                                                                    {{ 'Art. Nr. Kunde' | translate }}
                                                                </document-item-label>
                                                                <document-item-value>
                                                                    {{ item.customerArticleSku }}
                                                                </document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        <document-item-attribute [spacingAbove]="true">
                                                            <document-item-label>
                                                                {{ 'Inhalt' | translate }}
                                                            </document-item-label>
                                                            <document-item-value>
                                                                {{ item.numberOfContentUnitsPerOrderUnit }}
                                                                {{
                                                                    item.contentUnit
                                                                        | unit: item.numberOfContentUnitsPerOrderUnit
                                                                }}
                                                            </document-item-value>
                                                        </document-item-attribute>
                                                        @if (item.note) {
                                                            <document-item-note>
                                                                {{ item.note }}
                                                            </document-item-note>
                                                        }
                                                        <document-item-price *showOnActiveWarehouse="+item.quantityStocked > 0">
                                                            <document-item-label>
                                                                <span
                                                                    [ngClass]="
                                                                        +item.quantityStocked < +item.quantity
                                                                            ? 'text-danger'
                                                                            : 'text-success'
                                                                    "
                                                                >
                                                                    {{ 'Eingelagerte Menge' | translate }}
                                                                </span>
                                                            </document-item-label>
                                                            <document-item-value>
                                                                <span
                                                                    [ngClass]="
                                                                        +item.quantityStocked < +item.quantity
                                                                            ? 'text-danger'
                                                                            : 'text-success'
                                                                    "
                                                                >
                                                                    {{ item.quantityStocked }}
                                                                    {{ item.orderUnit | unit: item.quantityStocked }}
                                                                </span>
                                                            </document-item-value>
                                                        </document-item-price>
                                                        <document-item-price>
                                                            <document-item-label>
                                                                <strong class="font-11">
                                                                    {{ 'Gelieferte Menge' | translate }}
                                                                </strong>
                                                            </document-item-label>
                                                            <document-item-value>
                                                                <span class="font-11">
                                                                    {{ item.quantity }}
                                                                    {{ item.orderUnit | unit: +item.quantity }}
                                                                </span>
                                                            </document-item-value>
                                                        </document-item-price>
                                                        @if (item.deliveryCompleted) {
                                                            <document-item-price>
                                                                <document-item-label>
                                                                    <span
                                                                        class="badge bg-info font-07 p-1 px-2 rounded-pill"
                                                                        data-testid="delivery-completed-badge"
                                                                        [title]="'Restmenge entfällt' | translate"
                                                                    >
                                                                        {{ 'Endlieferung' | translate }}
                                                                    </span>
                                                                </document-item-label>
                                                            </document-item-price>
                                                        }
                                                    </document-item>
                                                }
                                            </iim-card>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </document-layout>
        </base-site-layout>
    } @else {
        <http-error-alert
            [statusCode]="errorStatusCode"
            [message404]="'Lieferschein konnte nicht gefunden werden.' | translate"
            [alertLevel500]="'Beim Laden des Lieferscheins ist leider ein Fehler aufgetreten.' | translate"
        ></http-error-alert>
    }
}
